module.exports = __webpack_public_path__ + "img/ms-tileimage.9a099b7a.png";